import React from 'react';
import PostForm from '../components/PostForm';

const CreatePostPage: React.FC = () => {
  return (
    <div>
      <PostForm />
    </div>
  );
};

export default CreatePostPage; 